import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const EpisodeCardSkeleton = props => {
  return (
    <div {...props} className="show-movie-card-skeleton">
      <Skeleton width="100%" height={160} variant="rect" />
      <Skeleton width="100%" height={50} />
    </div>
  );
};

export default React.memo(EpisodeCardSkeleton);
